export const SET_PRODUCT = 'STORE/PRODUCT/SET_PRODUCT'
export const SET_PRODUCTS = 'STORE/PRODUCT/SET_PRODUCTS'
